import request from '@/utils/request';

// 查询课桌统计
export function getDeskList(options) {
  return request({
    url: '/op/statistical/querydesk',
    method: 'get',
    params: options
  });
}

// 查询课桌售后统计
export function getAfterSaleList(options) {
  return request({
    url: '/op/statistical/queryaftersale',
    method: 'get',
    params: options
  });
}

// 查询课桌售后详情
export function getAfterSaleDetail(deviceNo) {
  return request({
    url: '/op/statistical/queryaftersaledetail',
    method: 'get',
    params: { deviceNo }
  });
}

// 查询APP统计
export function getAppList(options) {
  return request({
    url: '/op/statistical/queryapp',
    method: 'get',
    params: options
  });
}

// 查询APP统计详情
export function getAppDetail(mobile) {
  return request({
    url: '/op/statistical/queryappdetail',
    method: 'get',
    params: mobile
  });
}

// 查询资源学段集合
export function getSourceList(options) {
  return request({
    url: '/source/list',
    method: 'get',
    params: options
  });
}
// 章节树相应的资源数据
export function getQueryNodeTree(options) {
  return request({
    url: `/source/queryNodeTree`,
    method: 'get',
    params: options
  });
}

// 查询版本统计
export function getVersionStatisticsList(options) {
  return request({
    url: '/op/statistical/queryVersionStatisticsPage',
    method: 'get',
    params: options
  });
}

// 查询版本统计详情
export function getVersionStatisticsDetail(options) {
  return request({
    url: '/op/statistical/queryVersionStatisticsDetailPage',
    method: 'get',
    params: options
  });
}
// 查询设备版本信息
export function getDeviceLatestVersion(options) {
  return request({
    url: '/op/statistical/queryDeviceLatestVersionPage',
    method: 'get',
    params: options
  });
}
